module.exports = __webpack_public_path__ + "static/media/galerija_2014 (1).4e50d586.jpg";